// extracted by mini-css-extract-plugin
module.exports = {"changeStatusSelector":"changeStatusSelector__3-zWe"};